<template>
  <div class="table-screes">
    <div class="screes-titel">
      <h2>筛选</h2>
      <img src="../../../../../static/images/close.png" class="closeicon" @click="closeClick">
    </div>
    <div class="screes-warpper">
      <van-collapse v-model="activeName" accordion @change="getName">
        <van-collapse-item name="1">
          <div slot="title">
            机构
            <div v-show="textShow" class='text'>{{showText}}</div>
          </div>
          <MyTreeSelect:filterType="'branch'"
          :items="branchs"
          v-on:chooseData1='getData1'
          v-on:chooseData2='getData2'>
          </MyTreeSelect:filterType="'branch'">
        </van-collapse-item>
        <van-collapse-item title="类型" name="2">
          <div class="itemBut">
            <van-button :class="{'itemButListH':itemBut.checked}" type="info" v-for="(itemBut, index) in this.itemButText" :key="index"  @click="itemButClick(itemBut)">{{itemBut.name}}</van-button>
          </div>
        </van-collapse-item>
        <van-collapse-item title="达成" name="3" class="inputBox">
          <div class="roupBox">
            <van-cell-group>
              <van-field v-model="value1" placeholder="最低(%)" />
            </van-cell-group>
            <span>—</span>
            <van-cell-group>
              <van-field v-model="value2" placeholder="最高(%)" />
            </van-cell-group>
          </div>
        </van-collapse-item>
        <van-collapse-item title="占比" name="4" class="inputBox">
          <div class="roupBox">
            <van-cell-group>
              <van-field v-model="value1" placeholder="最低(%)" />
            </van-cell-group>
            <span>—</span>
            <van-cell-group>
              <van-field v-model="value2" placeholder="最高(%)" />
            </van-cell-group>
          </div>
        </van-collapse-item>
        <van-collapse-item title="达成率" name="5" class="inputBox">
          <div class="roupBox">
            <van-cell-group>
              <van-field v-model="value1" placeholder="最低(%)" />
            </van-cell-group>
            <span>—</span>
            <van-cell-group>
              <van-field v-model="value2" placeholder="最高(%)" />
            </van-cell-group>
          </div>
        </van-collapse-item>
        <van-collapse-item name="6" title="主销产品">
          <MyTreeSelect :filterType="'product'" :items="products"></MyTreeSelect>
        </van-collapse-item>
      </van-collapse>
    </div>
    <div class="screes-footer">
      <button @click="childClick">取消</button>
      <button @click="childClick">确定</button>
    </div>
  </div>

</template>

<script>
import MyTreeSelect from './MyTreeSelect'
// import MyTreeSelect from './MyTreeSelect1'
// import axios from 'axios'
import { postAction } from '@/utils/api'
export default {
  name: 'TablesScreens',
  components: {
    MyTreeSelect
  },
  data () {
    return {
      childByValue: false,
      type: '',
      childValue: false,
      activeName: '0',
      branchs: [],
      products: [],
      rates: {},
      sliderValue: [],
      sliderTick: [],
      firstLevel: [],
      secondLevel: [],
      showText: '',
      textShow: false,
      itemButText: [
        {
          id: 1,
          name: '人寿'
        },
        {
          id: 2,
          name: '年金'
        },
        {
          id: 3,
          name: '健康'
        },
        {
          id: 4,
          name: '意外'
        }
      ]
    }
  },
  methods: {
    getName (activeNames) {
      this.showText = ''
      if (activeNames === '1') {
        this.textShow = false
      } else {
        for (var i in this.firstLevel) {
          let chooseParent = this.firstLevel[i].orgCode
          let chooseChild = []
          for (var j in this.secondLevel) {
            if (this.secondLevel[j].parentId === chooseParent) {
              chooseChild.push(this.secondLevel[j])
            }
          }
          if (chooseChild.length > 0) {
            this.showText = this.showText + '' + this.firstLevel[i].orgSname
            for (let i = 0; i < chooseChild.length; i++) {
              if (i === 0) {
                this.showText = this.showText + '-' + chooseChild[i].orgSname
              } else {
                this.showText = this.showText + '、' + chooseChild[i].orgSname
              }
            }
            this.showText = this.showText + ';'
          }
        }
        this.textShow = true
      }
    },
    childClick () {
      this.$emit('childByValue', this.childValue)
    },
    itemButClick (itemBut) {
      this.$set(itemBut, 'checked', !itemBut.checked)
    },
    closeClick () {
      this.$emit('childByValue', this.childValue)
    },
    getFilterData (data) {
      if (data.data) {
        this.branchs = data.data
        // this.branchs = data.data.data.groups
        this.rates = data.data.data.retas
        this.rates.left = (100 / (data.data.data.retas.avgBlock.length + 2)) + '%'

        this.products = data.data.data.products

        this.sliderValue.push(this.rates.minNum)
        this.sliderValue.push(this.rates.maxNum * 0.5)
      }
    },
    getData1 (data) {
      this.firstLevel = data
    },
    getData2 (data) {
      this.secondLevel = data
    }
  },
  created () {
    let postData = {
      'channelId': '01',
      'classification': '010101',
      'date': '',
      'indexId': 'A0101-1007',
      'level': 1,
      'orgId': 86,
      'analytyType': 1
    }
    let obj = postAction('/simpapp/Filtrate/getList', postData)
    obj.then(this.getFilterData)
    // axios.get('/api/showtable1.json').then(this.getFilterData)
  },
  watch: {
    // getData1 () {
    //   this.$nextTick(() => {
    //   })
    // },
    // getData2 () {
    //   this.$nextTick(() => {
    //   })
    // }
  }
}
</script>

<style lang="stylus" scoped>
.table-screes{
  margin : 0 auto;
  text-align : center;
}
.screes-titel, .screes-titel h2{
  height 0.5rem
  line-height .5rem
}
.screes-warpper{
  text-align : left;
  height: 3rem;
  overflow: hidden;
  overflow-y: scroll;
}
.screes-all span{
  margin-right : .2rem;
}
.screes-city{
  margin-top : .1rem;
  display : flex;
  justify-content : center;
}
.screes-city .van-button{
  flex : 1;
  margin : .01rem;
  font-size : 2vw;
  height : auto;
  line-height : 3;
}
.van-button--normal{
  padding : .01rem;
}
.screes-footer{
  display: flex;
  text-align: center;
  align-items: center;
  justify-content: stretch;
}
.screes-footer>button{
  background-color: #fff;
  flex-grow:1;
  box-sizing: border-box;
  padding:.08rem 0;
}
.screes-footer>button:nth-child(1){
  border-top:1px solid #bfbfbf;
  color:#bfbfbf;
}
.screes-footer>button:nth-child(2){
  border-top:1px solid #3399ff;
  color:#fff;
  background-color: #3399ff;
}
.complete-rate{
  overflow:hidden;
  box-sizing:border-box;

}
.complete-rate>div{
  border:1px solid #f9f9f9;
  width:30%;
  float:left;
  padding:.12rem 0;
  text-align: center;
  margin-left:2.5%;
  margin-bottom:2.5%;
  border-radius:.06rem;
  background-color: #f9f9f9;
  color:#999999;
}
.sliderTick{
  overflow:hidden;
}
.sliderTick>div{
  box-sizing: border-box;
  float:left;
}
.sliderTick>div:last-child{
  float:right;
}
.screes-warpper>>>.el-slider__button{
  width: 25px;
  height: 25px;
  box-shadow: 0px 0px 15px #ddd;
  border: none;
}
.sliderCurrent{
  text-align: center;
  color:#3399ff;
}

.itemBut{
  display : flex;
  justify-content : space-around;
}
.itemBut>button{
  display : block;
  color: #1989fa;
  background-color: #fff;
  border: 1px solid #1989fa;
  padding: 0 0.05rem;
}
// .itemButList{
//   display : block;
//   color: #1989fa;
//   background-color: #fff;
//   border: 1px solid #1989fa;
//   padding: 0 0.2rem;
// }
.itemButListH{
  color: #fff !important;
  background-color: #1989fa !important;
  border-width : 0;
}
.text {
  color:#999;
  font-weight:normal;
  margin:10px 0 8px 0;
  width:100%;
  word-break:break-all;
  text-overflow:ellipsis;//显示为省略号
  display:-webkit-box;//对象作为伸缩盒子模型显示
  -webkit-box-orient:vertical;//设置或检索伸缩盒对象的子元素的排列方式
  -webkit-line-clamp:2;//显示行数## 标题文字 ##
  overflow:hidden;
}
.screes-warpper>>>.van-collapse-item__content {
  padding: 0!important;
}
.van-cell{
  color: #999!important;
  font-weight:normal
}
.inputBox .van-cell-group{
  display inline-block
  width:30%;
  border:none
}
.van-cell.van-field{
  background-color:#f9f9f9 !important
}
.closeicon {
  position: absolute;
  width:.21rem;
  height:.2rem
  top: 15px;
  right: 16px;
  text-align: center;
}
.roupBox{
  display: flex;
  /* align-content: center; */
  align-items: center;
  justify-content: center;
}
</style>



// WEBPACK FOOTER //
// src/pages/entirety/components/screens/Screens.vue